/* eslint-disable @next/next/no-img-element */
// components
import { Container } from 'components/Grid';
import { SectionTitle } from '@/components/SectionTitle';

// styles
import {
  SectionWrapper,
  TitleWrapper,
  CTAWrapper,
  Picture,
  StyledButton,
  StyledButtonHollow,
} from './ImageCTA.styles';

export function ImageCTA() {
  return (
    <SectionWrapper>
      <Container>
        <TitleWrapper>
          <SectionTitle
            title={
              <>
                Easy procurement and
                <br /> execution, in one place.
              </>
            }
            subtitle={`Say goodbye to complex logistics systems`}
            variant="center"
          />
        </TitleWrapper>
        <CTAWrapper>
          <StyledButton as="a" href="#hubspot-form">
            REQUEST A DEMO
          </StyledButton>
          <StyledButtonHollow
            as="a"
            target="_blank"
            rel="noopener noreferrer"
            href={`${process.env.SHIPPERGUIDE_URL}/signup`}
          >
            TRY SHIPPERGUIDE NOW
          </StyledButtonHollow>
        </CTAWrapper>
        <Picture>
          <source
            srcSet={`/images/shipperguide/image-cta/shipperguide-dashboard@2x.png`}
            media="(min-width: 1920px)"
          />
          <source
            srcSet={`/images/shipperguide/image-cta/shipperguide-dashboard@2x.png`}
            media="(min-width: 1024px)"
          />
          <source
            srcSet={`/images/shipperguide/image-cta/shipperguide-dashboard@2x.png`}
            media="(min-width: 768px)"
          />
          <img
            srcSet={`/images/shipperguide/image-cta/shipperguide-dashboard@2x.png`}
            alt="Shipper Guide dashboard screen"
            width="677"
            height="520"
          />
        </Picture>
      </Container>
    </SectionWrapper>
  );
}
